import CloseIcon from "@mui/icons-material/Close";
import { Box, Container, IconButton, Modal, Paper } from "@mui/material";
import React from "react";
import MuiTabs, { TabsDetails } from "./MuiTabs";

interface ModalWithMuiTabsProps {
  isOpen: boolean;
  handleClose: () => void;
  tabDetails: TabsDetails[];
}

const ModalWithMuiTabs: React.FC<ModalWithMuiTabsProps> = ({
  isOpen,
  handleClose,
  tabDetails,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      style={{ overflow: "scroll", marginTop: "3%" }}
    >
      <Container
        component={Paper}
        style={{ marginTop: "2%", height: "auto", position: "relative" }}
      >
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ paddingTop: "25px" }}>
          <MuiTabs tabDetails={tabDetails} />
        </Box>
      </Container>
    </Modal>
  );
};

export default ModalWithMuiTabs;
